const box = [
  {
    category: 'Video',
    value: 'media',
    icon: 'proicons:video-clip',
    options: [
      {
        name: 'Single video',
        image: '/assets/editor-file/media/singlevideo.png',
        html: `  <div class="simple-box-wrapper"> 
                  <div class="simple-box">
                    <div class="column">
                      <div class="video-wrapper">  
                        <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&log_user=0&signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9"></video>
                      </div>
                    </div>
                  </div>
                </div>`,
      },
      {
        name: 'Video on the top',
        image: '/assets/editor-file/media/videoonthetop.png',
        html: ` <div class="simple-box-wrapper"> 
                <div class="simple-box">
                  <div class="column">
                    <div class="video-wrapper">  
                      <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&log_user=0&signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9"></video>
                    </div>
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
                  </div>
                </div>
                </div>
                `,
      },
      {
        name: 'Video on the bottom',
        image: '/assets/editor-file/media/videoonthebottom.png',
        html: `<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column"> 
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
                    <div class="video-wrapper"> 
                      <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&log_user=0&signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9"></video>
                    </div>
                  </div>
                </div>
              </div>`,
      },
      {
        name: 'Two videos',
        image: '/assets/editor-file/media/twovideos.png',
        html: `<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                    <div class="video-wrapper"> 
                      <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&log_user=0&signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9"></video>
                    </div>
                    <h2>Heading </h2><p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  <div class="column"> 
                    <div class="video-wrapper">  
                      <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&log_user=0&signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9"></video>
                    </div>
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                </div>
              </div>`,
      },
      {
        name: 'Video on the left',
        image: '/assets/editor-file/media/videoontheleft.png',
        html: `<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column"> 
                    <div class="video-wrapper">
                      <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&log_user=0&signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9"></video>
                    </div>
                  </div>
                  <div class="column">
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                </div>
              </div>`,
      },
      {
        name: 'Video on the right',
        image: '/assets/editor-file/media/videoontheright.png',
        html: `<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column"> 
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  <div class="column">
                    <div class="video-wrapper">
                      <video class="video-player" src="https://player.vimeo.com/progressive_redirect/playback/1038160884/rendition/720p/file.mp4?loc=external&log_user=0&signature=e3371f1c844e5717ebef8396e458b401366fbbb67b1778a783d56e38494ea377" aspectratio="16/9" ></video>
                    </div>
                  </div>
                </div>
              </div>`,
      },
      /*{
        name: 'Single audio',
        image: '/assets/editor-file/media/singleaudio.png',
      },*/
    ],
  },
  {
    category: 'Image',
    value: 'image',
    icon: 'proicons:photo',
    options: [
      {
        name: 'Single image',
        image: '/assets/editor-file/image/singleimage.png',
        html: `<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                    <div class="img-wrapper" background-image="" background-color="">
                      <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                    </div>
                  </div>
                </div>
              </div>`,
      },
      {
        name: 'Image on the top',
        image: '/assets/editor-file/image/imageonthetop.png',
        html: `<div class="simple-box-wrapper"> 
                  <div class="simple-box">
                    <div class="column">
                      <div class="img-wrapper">
                        <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                      </div>
                      <h2>Heading </h2>
                      <p>I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
                    </div>
                  </div>
                </div>`,
      },
      {
        name: 'Image on the bottom',
        image: '/assets/editor-file/image/imageonthebottom.png',
        html: `<div class="simple-box-wrapper"> 
                <div class="simple-box">
                    <div class="column">
                      <h2>Heading </h2>
                      <p>I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
                      <div class="img-wrapper">
                        <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                      </div>
                    </div>
                  </div>
                </div>`,
      },
      {
        name: 'Two images',
        image: '/assets/editor-file/image/twoimages.png',
        html: ` <div class="simple-box-wrapper"> 
                  <div class="simple-box">
                      <div class="column">
                        <div class="img-wrapper" aspectratio="16/9">
                          <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                        </div>
                        <h2>Heading </h2>
                        <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                      </div>
                      <div class="column">
                        <div class="img-wrapper" aspectratio="16/9">
                          <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                        </div>
                        <h2>Heading </h2>
                        <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                      </div>
                    </div>
                </div>`,
      },
      {
        name: 'Three images',
        image: '/assets/editor-file/image/threeimages.png',
        html: ` <div class="simple-box-wrapper"> 
                 <div class="simple-box">
                  <div class="column">
                    <div class="img-wrapper" aspectratio="16/9">
                      <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg""></img>
                    </div><h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  <div class="column">
                    <div class="img-wrapper" aspectratio="16/9">
                      <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                    </div>
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  <div class="column">
                    <div class="img-wrapper" aspectratio="16/9">
                      <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                    </div><h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  </div>
                </div>`,
      },
      {
        name: 'Image on the left',
        image: '/assets/editor-file/image/imageontheleft.png',
        html: `<div class="simple-box-wrapper"> 
                 <div class="simple-box">
                  <div class="column">
                    <div class="img-wrapper">
                      <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                    </div></div>
                  <div class="column">
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  </div>
                </div>`,
      },
      {
        name: 'Image on the right',
        image: '/assets/editor-file/image/imageontheright.png',
        html: `<div class="simple-box-wrapper"> 
                <div class="simple-box">
                <div class="column">
                  <h2>Heading </h2>
                  <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                </div>
                <div class="column">
                  <div class="img-wrapper">
                    <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                  </div>
                </div>
                </div>
              </div>`,
      },
      {
        name: 'Image with buttons',
        image: '/assets/editor-file/image/imagewithbuttons.png',
        html: `<div class="simple-box-wrapper"> 
                 <div class="simple-box">
                  <div class="column">
                    <div class="img-wrapper">
                      <img src="https://cdn.minicoursegenerator.com/assets/editor/sample-img.jpg"></img>
                    </div></div>
                  <div class="column">
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  <div class="button-wrapper" data-sizing="fit">
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text="Button"><iconify-icon width="18" height="18" class="simple-icon" iconname="hugeicons:checkmark-circle-02" icon="hugeicons:checkmark-circle-02"></iconify-icon>Button</a>
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text="Button"><iconify-icon width="18" height="18" class="simple-icon" iconname="hugeicons:checkmark-circle-02" icon="hugeicons:checkmark-circle-02"></iconify-icon>Button</a>
                      </div>
                    </div>
                  </div>
                </div>`,
      },
    ],
  },
  {
    category: 'Text',
    value: 'text',
    icon: 'proicons:text-highlight-color',
    options: [
      {
        name: 'Heading and Text',
        image: '/assets/editor-file/text/headertext.png',
        html: `<div class="simple-box-wrapper"> 
              <div class="simple-box">
                  <div class="column">
                    <h2>Heading </h2>
                    <p id="awdawd">I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
                    </div>
                </div>
              </div>`,
      },
      {
        name: 'Text',
        image: '/assets/editor-file/text/text.png',
        html: ` <div class="simple-box-wrapper"> 
            <div class="simple-box">
              <div class="column">
                <p>I'm a paragraph. Click to start writing that will inform, inspire, or encourage your community. We know you have so many things to share with the world. Happy editing!</p>
              </div>
            </div>
          </div>`,
      },
      {
        name: 'Two Columns',
        image: '/assets/editor-file/text/twocolumns.png',

        html: ` 
                <div class="simple-box-wrapper"> 
                  <div class="simple-box">
                    <div class="column"><h2>Heading </h2><p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p></div>
                    <div class="column"><h2>Heading </h2><p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p></div>
                  </div>
                </div>`,
      },
      {
        name: 'Two Columns List',
        image: '/assets/editor-file/text/twocolumns.png',

        html: ` 
                <div class="simple-box-wrapper"> 
                  <div class="simple-box">
                   <div class="column">
                   <h2>Heading </h2>
                   <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                     <div class="column-header"><p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p></div>
                    <div class="column-header"><p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p></div>
                 
                   </div>
                  </div>
                </div>`,
      },
      {
        name: 'Three Columns',
        image: '/assets/editor-file/text/threecolumn.png',
        html: `<div class="simple-box-wrapper"> 
                <div class="simple-box">
                  <div class="column">
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  <div class="column">
                      <h2>Heading </h2>
                      <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                  <div class="column">
                    <h2>Heading </h2>
                    <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                  </div>
                </div>
              </div>`,
      },
      {
        name: 'Quote',
        image: '/assets/editor-file/text/quote.png',
        html: `<div class="simple-box-wrapper"> 
                  <div class="simple-box">
                    <blockquote>
                      <h2>Every idea is a seed. Let’s help it grow together.</h2>
                      <p><i>––Mini-Course Generator Team</i></p>
                    </blockquote>
                  </div>
              </div>`,
      },
      {
        name: 'Table',
        image: '/assets/editor-file/text/table.png',
        html: `
        <div class="simple-box-wrapper"> 
          <div class="simple-box">
            <div class="column">
                <table>
                    <tr>
                        <th>Column 1</th>
                        <th>Column 2</th>
                        <th>Column 3</th>
                        <th>Column 4</th>
                    </tr>
                    <tr>
                        <td>Text</td>
                        <td>Text</td>
                        <td>Text</td>
                        <td>Text</td>
                    </tr>
                    <tr>
                        <td>Text</td>
                        <td>Text</td>
                        <td>Text</td>
                        <td>Text</td> 
                    </tr>
                </table>
            </div>
          </div>
        </div>
     `,
      },
    ],
  },
  // {
  //   category: 'Docs',
  //   value: 'docs',
  //   icon: 'proicons:file',
  //   options: [
  //     {
  //       name: 'Document',
  //       image: '/assets/editor-file/document/document.png',
  //     },
  //   ],
  // },
  {
    category: 'Actions',
    value: 'actions',
    icon: 'proicons:cursor-click',
    options: [
      {
        name: 'AI interaction builder',
        value: 'interactiveActivity',
        image: '/assets/editor-file/actions/interactiveActivity.png',
        html: `<div class="drop-area-narrow"></div>`,
      },
      {
        name: 'Flip card',
        value: 'fitButton',
        image: '/assets/editor-file/actions/flipCard.png',
        html: `<div class="simple-box-wrapper">
                <div class="simple-box">
                  <div class="column">
                    <div class="card-wrapper">
                      <div class="card-box" type="flipCard">
                        <div class="flip-card-front">
                          <p>Front of Card 1</p>
                          <button class="flip-card-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 2v6h-6"></path>
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                              <path d="M3 22v-6h6"></path>
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                            </svg>
                          </button>
                        </div>
                        <div class="flip-card-back">
                          <p>Back of Card 1</p>
                          <button class="flip-card-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 2v6h-6"></path>
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                              <path d="M3 22v-6h6"></path>
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div class="card-box" type="flipCard">
                        <div class="flip-card-front">
                          <p>Front of Card 2</p>
                          <button class="flip-card-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 2v6h-6"></path>
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                              <path d="M3 22v-6h6"></path>
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                            </svg>
                          </button>
                        </div>
                        <div class="flip-card-back">
                          <p>Back of Card 2</p>
                          <button class="flip-card-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 2v6h-6"></path>
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                              <path d="M3 22v-6h6"></path>
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div class="card-box" type="flipCard">
                        <div class="flip-card-front">
                          <p>Front of Card 3</p>
                          <button class="flip-card-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 2v6h-6"></path>
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                              <path d="M3 22v-6h6"></path>
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                            </svg>
                          </button>
                        </div>
                        <div class="flip-card-back">
                          <p>Back of Card 3</p>
                          <button class="flip-card-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                              <path d="M21 2v6h-6"></path>
                              <path d="M3 12a9 9 0 0 1 15-6.7L21 8"></path>
                              <path d="M3 22v-6h6"></path>
                              <path d="M21 12a9 9 0 0 1-15 6.7L3 16"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>`,

        class: 'simple-button',
      },
      {
        name: 'Fit button',
        value: 'fitButton',
        image: '/assets/editor-file/actions/fitButton.png',
        html: ` <div class="simple-box-wrapper">
                  <div class="simple-box">
                    <div class="column">
                      <div class="button-wrapper" data-sizing="fit">
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text="Button"><iconify-icon width="18" height="18" class="simple-icon" iconname="lets-icons:add-round" icon=""></iconify-icon>Button</a>
                      </div>
                    </div>
                  </div>
              </div>`,

        class: 'simple-button',
      },
      {
        name: 'Full button',
        value: 'fullButton',
        image: '/assets/editor-file/actions/fullButton.png',
        html: ` <div class="simple-box-wrapper">
                  <div class="simple-box">
                    <div class="column">
                      <div class="button-wrapper" data-sizing="full">
                       <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text="Button"><iconify-icon width="18" height="18" class="simple-icon" iconname="lets-icons:add-round" icon=""></iconify-icon>Button</a>
                      </div>
                    </div>
                  </div>
              </div>`,
      },
      {
        name: 'Social button',
        value: 'socialButton',
        image: '/assets/editor-file/actions/socialButton.png',
        html: ` <div class="simple-box-wrapper">
                  <div class="simple-box">
                    <div class="column">
                      <div class="button-wrapper" data-alignment="center">
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text=""><iconify-icon width="18" height="18" class="simple-icon" iconname="hugeicons:new-twitter" icon="hugeicons:new-twitter"></iconify-icon></a>
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text=""><iconify-icon width="18" height="18" class="simple-icon" iconname="hugeicons:dribbble" icon="hugeicons:dribbble"></iconify-icon></a>
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text=""><iconify-icon width="18" height="18" class="simple-icon" iconname="hugeicons:twitch" icon="hugeicons:twitch"></iconify-icon></a>
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text=""><iconify-icon width="18" height="18" class="simple-icon" iconname="hugeicons:tiktok" icon="hugeicons:tiktok"></iconify-icon></a>
                      </div>
                    </div>
                  </div>
              </div>`,
      },
      {
        name: 'Button on the right',
        value: 'buttonOnTheRight',
        image: '/assets/editor-file/actions/buttonOnTheRight.png',
        html: ` <div class="simple-box-wrapper">
                  <div class="simple-box">
                    <div class="column" flex-size="3/1">
                      <p>I’m a paragraph. Write a description here to explain this button’s purpose or destination.</p>
                    </div>
                    <div class="column" flex-size="1/3">
                      <div class="button-wrapper">
                        <a class="simple-button" href="" textcolor="#002E47" pdfname="" type="link" text="Button"><iconify-icon width="18" height="18" class="simple-icon" iconname="lets-icons:add-round" icon=""></iconify-icon>Button</a>
                      </div>
                    </div>
                  </div>
              </div>`,
      },
      {
        name: 'Numbered cards',
        value: 'numberedCards',
        image: '/assets/editor-file/actions/numberedCards.png',
        html: ` <div class="simple-box-wrapper">
                  <div class="simple-box">
                    <div class="column">
                      <div class="card-wrapper">
                      <div class="card-box" type="numberedCard">
                        <div class="card-header"><p>01</p></div>
                        <div class="card-content">
                          <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                        </div>
                      </div>
                      <div class="card-box" type="numberedCard">
                        <div class="card-header"><p>02</p></div>
                        <div class="card-content">
                          <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                        </div>
                      </div>
                      <div class="card-box" type="numberedCard">
                        <div class="card-header"><p>03</p></div>
                        <div class="card-content">
                          <p>I'm a paragraph. Click to start writing to inform, inspire, or encourage your community. Happy editing!</p>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
              </div>`,
      },
      {
        name: 'Highlights',
        value: 'highlights',
        image: '/assets/editor-file/actions/highlights.png',
        html: ` <div class="simple-box-wrapper">
                  <div class="simple-box">
                    <div class="column">
                      <div class="card-wrapper">
                        <div class="card-box" type="highlightCard">
                          <div class="card-header">
                            <button class="card-icon-button">
                              <iconify-icon class="simple-icon" width="24" height="24" iconname="lets-icons:add-round" icon="lets-icons:add-round"></iconify-icon>
                            </button>
                          </div>
                          <div class="card-content">
                             <p>Normal text</p>
                          </div>
                        </div>
                        <div class="card-box" type="highlightCard">
                        <div class="card-header">
                          <button class="card-icon-button">
                            <iconify-icon class="simple-icon" width="24" height="24" iconname="lets-icons:add-round" icon="lets-icons:add-round"></iconify-icon>
                          </button>
                        </div>
                        <div class="card-content">
                           <p>Normal text</p>
                        </div>
                      </div>
                      <div class="card-box" type="highlightCard">
                        <div class="card-header">
                          <button class="card-icon-button">
                            <iconify-icon class="simple-icon" width="24" height="24" iconname="lets-icons:add-round" icon="lets-icons:add-round"></iconify-icon>
                          </button>
                        </div>
                        <div class="card-content">
                           <p>Normal text</p>
                        </div>
                      </div>
                       <div class="card-box" type="highlightCard">
                        <div class="card-header">
                          <button class="card-icon-button">
                            <iconify-icon class="simple-icon" width="24" height="24" iconname="lets-icons:add-round" icon="lets-icons:add-round"></iconify-icon>
                          </button>
                        </div>
                        <div class="card-content">
                          <p>Normal text</p>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
              </div>`,
      },
    ],
  },
  {
    category: 'Embed',
    value: 'embed',
    icon: 'proicons:code',
    options: [
      {
        name: 'Web link',
        value: 'webLink',
        image: '/assets/editor-file/embed/webLinkBox.png',
        modalImg: '/assets/editor-file/embed/webLinkModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Web link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'HTML',
        value: 'html',
        image: '/assets/editor-file/embed/htmlBox.png',
        modalImg: '/assets/editor-file/embed/htmlModal.png',
        message: 'Embed HTML code into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
        html: `<div class="drop-area-narrow"></div>`,
      },
      {
        name: 'YouTube',
        value: 'youtube',
        image: '/assets/editor-file/embed/youtubeBox.png',
        modalImg: '/assets/editor-file/embed/youtubeModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Youtube link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Canva',
        value: 'canva',
        image: '/assets/editor-file/embed/canvaBox.png',
        modalImg: '/assets/editor-file/embed/canvaModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Canva link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Vimeo',
        value: 'vimeo',
        image: '/assets/editor-file/embed/vimeoBox.png',
        modalImg: '/assets/editor-file/embed/vimeoModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Vimeo link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Google Services',
        value: 'googleServices',
        image: '/assets/editor-file/embed/googleServicesBox.png',
        modalImg: '/assets/editor-file/embed/googleServicesModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Google services link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Calendly',
        value: 'calendly',
        image: '/assets/editor-file/embed/calendlyBox.png',
        modalImg: '/assets/editor-file/embed/calendlyModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Calendly link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Scribe',
        value: 'scribe',
        image: '/assets/editor-file/embed/scribeBox.png',
        modalImg: '/assets/editor-file/embed/scribeModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Scribe link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'SoundCloud',
        value: 'soundCloud',
        image: '/assets/editor-file/embed/soundCloudBox.png',
        modalImg: '/assets/editor-file/embed/soundCloudModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed SoundCloud link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Spotify',
        value: 'spotify',
        image: '/assets/editor-file/embed/spotifyBox.png',
        modalImg: '/assets/editor-file/embed/spotifyModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Spotify link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Loom',
        value: 'loom',
        image: '/assets/editor-file/embed/loomBox.png',
        modalImg: '/assets/editor-file/embed/loomModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Loom link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Airtable',
        value: 'airtable',
        image: '/assets/editor-file/embed/airTableBox.png',
        modalImg: '/assets/editor-file/embed/airTableModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed Airtable link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'H5P',
        value: 'h5p',
        image: '/assets/editor-file/embed/h5pBox.png',
        modalImg: '/assets/editor-file/embed/h5pModal.png',
        html: `<div class="drop-area-narrow"></div>`,
        message: 'Embed H5P link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
      {
        name: 'Synthesia',
        value: 'synthesia',
        image: '/assets/editor-file/embed/synthesiaBox.png',
        modalImg: '/assets/editor-file/embed/synthesiaModal.png',
        html: ` <div class="simple-box">
      <div class="column">
        <iframe class="iframe-player" src=""></iframe>
      </div>
     </div>`,
        message: 'Embed Synthesia link into your mini-course.',
        url: 'https://intercom.help/mini-course-generator/en/',
      },
    ],
  },
]
export default box
